import React from 'react';
import { useQuery } from '@apollo/client';
import { t, defineMessages } from '@sm/intl';
import { createURL } from '@sm/utils';
import { TopBarSlim } from '../../TopBarSlim';
import { TopBarSlimThemes } from '../../TopBarSlimEnums';
import domainLockdownTopBarQuery from './DomainLockdownTopBarSlim.graphql';
import TopBarSlimSkeleton from '../../TopBarSlimSkeleton';
import { EmptyComponent } from '../../../helpers/EmptyComponent';

const COPY = defineMessages({
  MESSAGE: {
    id: 'DomainLockdownTopBarSlim.message',
    defaultMessage:
      'You have {lockdownDays, plural, one { 1 day } other {{ lockdownDays } days}} to update your existing account to an enterprise or personal account.',
    description: '[Type: Paragraph][Vis.: low] - Top bar slim message',
  },
  CTA_TEXT: {
    id: 'DomainLockdownTopBarSlim.ctaText',
    defaultMessage: 'Update Account',
    description: '[Type: Button][Vis.: low] - Top bar slim cta text',
  },
  BOLD_PREFIX: {
    id: 'DomainLockdownTopBarSlim.prefix',
    defaultMessage: 'REMINDER:',
    description: '[Type: Header][Vis.: low] - Top bar slim prefix',
  },
});

export type DomainLockdownTopBarSlimProps = {
  showLoaderOnFetch?: boolean;
};

export const DomainLockdownTopBarSlim: React.FC<
  DomainLockdownTopBarSlimProps
> = ({ showLoaderOnFetch }) => {
  const LoaderComponent: React.FC = showLoaderOnFetch
    ? TopBarSlimSkeleton
    : EmptyComponent;

  // Fetch data required for component
  const { loading, error, data } = useQuery(domainLockdownTopBarQuery);
  const lockdownDays = data?.user?.emailDomain?.lockdown?.daysToLockdown;

  return (
    <>
      {loading ? (
        <LoaderComponent />
      ) : error || !lockdownDays ? (
        <EmptyComponent />
      ) : (
        <TopBarSlim
          message={t(COPY.MESSAGE, { lockdownDays })}
          ctaText={t(COPY.CTA_TEXT)}
          ctaLink={createURL('/user/join-corporate-plan/', {
            ut_source: 'topbar',
            ut_source2: 'domain_lockdown',
          })}
          theme={TopBarSlimThemes.warning}
          prefix={t(COPY.BOLD_PREFIX)}
        />
      )}
    </>
  );
};

export default DomainLockdownTopBarSlim;
